import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import {input} from "../../utils/linker";
import {ComponentContext} from "../../contexts";

function TableFieldSelector(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount
    compContext.fetchAllTableFields();
    return () => {
      // unmount
    }
  }, []);
  
  const getFieldsList=(filterOnly=false)=>{
    if(compContext.all_table_fields.inited) {
      return compContext.all_table_fields.data.filter((data)=>{
        if(filterOnly) {
          return data.filter_type;
        }
        return true;
      })
    }
    return null;
  }
  
  const allFileds=getFieldsList(props.filter);
  if(!allFileds) {
    return null;
  }

  return (
    <div>
      <span className="select w100"><select {...input(props.linker, "value")}>
        <option value=""></option>
        {allFileds.map((item)=>{
          return (
            <option value={item.code}>{item.name} [{item.code}]</option>
          )
        })}
      </select></span>
    </div>
  )
};

TableFieldSelector.defaultProps = {};

TableFieldSelector.propTypes = {}

export default observer(TableFieldSelector);
